import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { FeedbackService } from './feedback.service';

@Component({
  selector: 'app-toast-stack',
  standalone: true,
  imports: [NgFor],
  template: `
    <div class="toast-stack">
      <button class="toast" *ngFor="let toast of feedback.toasts()" [class]="toast.type" (click)="feedback.dismiss(toast.id)">
        {{ toast.text }}
      </button>
    </div>
  `,
  styles: [`
    .toast-stack {
      position: fixed;
      top: 18px;
      right: 18px;
      z-index: 2000;
      display: grid;
      gap: 10px;
      width: min(360px, calc(100vw - 24px));
    }
    .toast {
      border: 1px solid rgba(15, 23, 42, 0.12);
      border-left-width: 4px;
      border-radius: 10px;
      background: #fff;
      color: #18212f;
      padding: 12px 14px;
      box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
      text-align: left;
      cursor: pointer;
      animation: slideIn 160ms ease-out;
    }
    .success { border-left-color: #0f766e; }
    .error { border-left-color: #b42318; }
    .warning { border-left-color: #b7791f; }
    .info { border-left-color: #2563eb; }
    @keyframes slideIn {
      from { transform: translateY(-8px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
  `]
})
export class ToastStackComponent {
  constructor(public feedback: FeedbackService) {}
}
